export default __webpack_public_path__ + "static/media/Flexco Industries.610218bf.png";